import { render, staticRenderFns } from "./alarm-detail-box.vue?vue&type=template&id=e55bf194&scoped=true"
import script from "./alarm-detail-box.vue?vue&type=script&lang=js"
export * from "./alarm-detail-box.vue?vue&type=script&lang=js"
import style0 from "./alarm-detail-box.vue?vue&type=style&index=0&id=e55bf194&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55bf194",
  null
  
)

export default component.exports